export default __webpack_public_path__ + "static/screenshot-dashboard-178dd9635f7aeba4673fe21786501349.png";